import { IDocumentSource, IDocumentIdentifiable } from "../../../domain/document";
import { AbstractSource } from "../../drawing";

export class DocumentPreviewSource extends AbstractSource implements IDocumentSource, IDocumentIdentifiable {
  constructor(getToken: () => string, public readonly id: number, public readonly edition: number, public readonly patientNo: string, public hasWatermark: boolean = false) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/document/" + this.id + "/view?token=" + this.token + "&edition=" + this.edition + "&patientCode=" + this.patientNo + "&hasWatermark=" + this.hasWatermark;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IDocumentSource {
    return new DocumentPreviewSource(
      this._getToken,
      this.id,
      this.edition,
      this.patientNo,
      this.hasWatermark
    );
  }
}
